import { api } from './client'
import type { CalEvent } from './calendar'
import type { MyStory } from './me'
import type { GCalEvent } from './gcal'

export type AgendaKind = 'event' | 'story_scheduled' | 'story_due' | 'google'

export type AgendaProject = {
  id: number
  key: string
  name: string
  color: string | null
}

/**
 * One entry on the personal calendar (GET /me/agenda). Exactly one of
 * `event` / `story` / `google` is set, matching `kind`. Times are naive
 * 'YYYY-MM-DD HH:MM:SS' wall-clock, like every other API datetime.
 */
export type AgendaItem = {
  kind: AgendaKind
  id: string
  title: string
  start_at: string
  end_at: string | null
  all_day: boolean
  color: string | null
  project: AgendaProject | null
  editable: boolean
  event?: CalEvent
  story?: MyStory
  google?: GCalEvent
  /** kind=story_scheduled: the work session this block is; count = the story's total. */
  session?: { id: number; start_at: string; end_at: string; count: number }
}

export type Agenda = {
  from: string
  to: string
  google: { connected: boolean; error: string | null }
  items: AgendaItem[]
}

export async function getAgenda(params: {
  from: string
  to: string
  project_ids?: number[]
  include_personal?: boolean
  include_google?: boolean
  include_done?: boolean
}): Promise<Agenda> {
  return api<Agenda>('/me/agenda', {
    query: {
      from: params.from,
      to: params.to,
      project_ids: params.project_ids?.join(','),
      include_personal: params.include_personal === false ? 0 : undefined,
      include_google: params.include_google ? 1 : undefined,
      include_done: params.include_done ? 1 : undefined,
    },
  })
}
